export default __webpack_public_path__ + "static/media/banner-1.75a1b130.jpg";